
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3912_24393)"}},[_c('path',{attrs:{"fill":"#5935DD","d":"M0 0h20v27.806H0z"}}),_c('path',{attrs:{"d":"M9.334 4h8M2.667 20h4M2.667 9.333h14.666M2.667 14.667h14.666","stroke":"#0C091B"}}),_c('path',{attrs:{"fill":"#E345FF","d":"M9.334 6.667h20v27.806h-20z"}}),_c('path',{attrs:{"d":"M18.666 12h8M12 28h4M12 17.333h14.667M12 22.667h14.667","stroke":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3912_24393"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    